module.exports = __webpack_public_path__ + "static/media/light-bulletin.1ead1e9b.svg";